export const userConstants = {
  USERS_SET_PAGE: 'USERS_SET_PAGE',

  USERS_RETRIEVE_REQUEST: 'USERS_RETRIEVE_REQUEST',
  USERS_RETRIEVE_SUCCESS: 'USERS_RETRIEVE_SUCCESS',
  USERS_RETRIEVE_FAILURE: 'USERS_RETRIEVE_FAILURE',

  SET_CURRENT_USER: 'SET_CURRENT_USER'
};